
import React, { Component } from "react";
import { Icon, Rate, Button, Row, Col } from 'antd'
import { Button as SVAButton } from 'antd'
import _ from 'lodash'
import moment from 'moment'





const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
        <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
);

const HeartIcon = props => <Icon component={HeartSvg} {...props} />;



class CliTerrainLocationSVPriceListView extends Component {

    reloadSJReviewPageSV = (ob) => (e) => {
        let me = this
        
        let cidOffer = {
            "offer": ob
        }
       

        me.props.sjSHIPofferselectparent(cidOffer, ob.id)


    }

    //sjjul14y25
    reloadSJCruisePageSV = (ob) => (e) => {
        let me = this
       
        let cidOffer = {
            "offer": ob
        }
      
        me.props.sjcruiseselectparent(cidOffer, ob)
       


    }
    reloadSJSrPageSV = (ob) => (e) => {
        let me = this
       
        let cidOffer = {
            "offer": ob
        }
      
        me.props.sjfarselectparent(cidOffer, ob)
       


    }
   
    reloadMyCliReservationReviewPageSV = (masterCustOffer) => (e) => {
        let me = this
        let ob = {
            price_key: 'PriceKey001Hw',
            flight_space_key: "k1"
        }
        let cidOffer = {
            "offer": ob
        }
        //TODDO THIS CODE BAD hardcode
        let svcustProfile = {
            customerId: -5
        }
      
        me.props.sjSHIPofferselectparent(cidOffer, ob.flight_space_key, svcustProfile)
        // history.back(-1)


        // history.push(`/myaccountSV/6/svaddress/-1`)


    }

    getFSKReserveHtmlButton(o, svcustProfile) {
        let me = this
        let customerId = -1


        if (!svcustProfile) {
            return (
                <div>
                    <SVAButton onClick={me.reloadSJCruisePageSV(o).bind(this)} style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" >SJCruise IDetail </SVAButton>


                    <SVAButton onClick={me.reloadSJReviewPageSV(o).bind(this)} style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" >SJ IReserve </SVAButton>
                    <SVAButton onClick={me.reloadSJSrPageSV(o).bind(this)} style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" >StateRoom </SVAButton>
                </div>
            )

        }
        if (typeof (svcustProfile.customerId) == "string") {
            customerId = parseInt(svcustProfile.customerId)
        } else {
            customerId = svcustProfile.customerId
        }
        
        if (customerId > 0) {
            let masterCustOffer = {
                "svcustProfile": svcustProfile,
                "o": o
            }
            return (<SVAButton onClick={me.reloadMyCliReservationReviewPageSV(masterCustOffer).bind(this)} style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" >MyFlightReserve </SVAButton>
            )
            /*
            return (<Button  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myflyreservationsSV/${customerId}/flyressvCustNew/${o.flight_space_key}`}> MyFlightReserve  </Link></Button>)
            */

        } else {
            //working July2y25 it will be hotelid extracted from ratekey


            return (<div>
                <SVAButton onClick={me.reloadSJCruisePageSV(o).bind(this)} style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" >Cruise Itinerary </SVAButton>


                <SVAButton onClick={me.reloadSJReviewPageSV(o).bind(this)} style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" >IReserve Spot </SVAButton>
                <SVAButton onClick={me.reloadSJSrPageSV(o).bind(this)} style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" >StateRoom </SVAButton>
            </div>)

        }

    }
   
    constructor(props) {
        super(props)
        let me = this
        this.location = {
            "resort_name": "253 Mancreek Resort",
            "address_line1": " 253 scottland av",
            "county": "albanyt",
            "postalcode": 12193,
            "market_code": "NAMER",
            "country": "usa",
            "region_desc_en": [
                "United States",
                "Coastal Mid Atlantic"
            ],
            "state": "NY",
        }
        
        this.reloadMyCliReservationReviewPageSV = this.reloadMyCliReservationReviewPageSV.bind(me)
        this.reloadSJCruisePageSV = this.reloadSJCruisePageSV.bind(me)
        /*svjuly17 start */
        this.reloadSJSrPageSV = this.reloadSJSrPageSV.bind(me)
         /*svjuly17 end */
        this.getFSKReserveHtmlButton = this.getFSKReserveHtmlButton.bind(this)


        

    }
   

    /*svmar16 start*/
    render() {
        const ars = [];
        let svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
       
        let customerId = -1
        let curr = '$'
        const { svcustProfile, excursionInfo } = this.props
      
        let o = {
            'hotel_soldout': 'y'
        }
        o = excursionInfo
        let svrDays='3 Days',dport='At Port', shipName='Luxury Cruise', itineraryTitle = 'Sea Excursion',  fromPrice = '$499', excursionId =-1, amount = 499
         
        let de = '', ds = '', dater = '', dayr = ''
        if(excursionInfo.exTrip ){
            itineraryTitle =  (excursionInfo.exTrip.itineraryTitle) ? excursionInfo.exTrip.itineraryTitle : itineraryTitle
            amount =  (excursionInfo.exTrip.fromPrice) ? excursionInfo.exTrip.fromPrice : amount
            fromPrice = `${curr}${amount}`
            let md = o.exTrip.departureDate
            let ma = o.exTrip.arrivalDate
            let momd = moment(md.split('T')[0])
           
            let moma =moment(ma.split('T')[0])
            ds =  momd.format("ddd,MMM Do YYYY")
            de =  moma.format("ddd,MMM Do YYYY")
            dater =  `${ds} - ${de}`
            dayr = `Depart On ${o.exTrip.departureDayOfWeek} - Arrive On ${o.exTrip.arrivalDayOfWeek}`
        }
        if(o.exTrip.dur && (o.exTrip.dur > 1)){
            svrDays = `${o.exTrip.dur} Days`
        }
        if(o.shipName){
            shipName = o.shipName
        }
        if(o.exTrip.departurePortName && _.isString(o.exTrip.departurePortName) && (o.exTrip.departurePortName.length > 1) ){
            dport = o.exTrip.departurePortName
        }
        
       
        if (svcustProfile && svcustProfile.customerId) {
            if (typeof (svcustProfile.customerId) == "string") {
                customerId = parseInt(svcustProfile.customerId)
            } else {
                customerId = svcustProfile.customerId
            }
            if (customerId > 0) {
                console.log('myreservationSpace')
            } else {
                console.log('internet userSpace')
            }
        }

        return (

            <div className="svr-clilist-boxr-1">
               
                <div className="svr-clilist-boxr-1">

                    <p>
                        <text className="svr-ex-ship">{shipName} </text>
                        <text className="svr-ex-name">{itineraryTitle}</text>
            
                        <text className="svr-ex-taxes">{dayr}  </text>
                        <text className="ter-l2 svr-ex-locationport">{dport}</text>

                    </p>


                </div>
               
                <div className="svr-clilist-boxr-1">

                    <p>
                        <text className="svr-ex-old-price">$558 </text>
                        <text className="svr-ex-price">{fromPrice} </text>
                        <text className="svr-ex-pricecon">average per person,2 peroom</text>

                        <text className="svr-ex-taxes">includes taxes and fees</text>
                      
                        <text className="svr-ex-dater">{dater}</text>
                        
                        <text className="svr-ex-dur">{svrDays} </text>

                    </p>


                </div>
                <div className="svr-clilist-boxr-1">

                    <p>
                        
                       
                        {this.getFSKReserveHtmlButton(o, svcustProfile)}


                    </p>


                </div>



            </div>

        )
    }
    /*svmar16 end */

}

export default CliTerrainLocationSVPriceListView;